import React from 'react'
import '../Styles/MCompany.css'
import Introduction from '../Components/Introduction'
import mcompany from '../Assets/logo-mcompany2.webp'
import Services from '../Components/Services'
import CardServices from '../Components/CardServices'
import GeographicPresence from '../Components/GeographicPresence'
import MarketAnalysis from '../Components/MarketAnalysis'

function MCompany({ id }) {
  return (
    <section id={id}>
      <Introduction
        id="mcompany-introduction"
        srcLogo={mcompany}
        altLogo="MCompany"
        description={
          <>
            A MCompany se firma como uma <span>referência em tokenização</span>,
            especializando-se na conversão de ativos tangíveis e intangíveis em
            tokens digitais por meio da blockchain. Atua na representação
            digital de uma variedade de ativos, como imóveis, commodities, obras
            de arte e ativos financeiros. A MCompany não apenas lidera em
            tokenização corporativa para multinacionais, mas também avança no
            desenvolvimento de tokens para games, além de coordenar operações de
            minério de ferro e petróleo.
          </>
        }
        color="white"
        img={false}
      />

      <Services colorTitle="rgb(112, 109, 126)">
        <CardServices
          title="Tokenização de Ativos"
          description="A MCompany facilita a transformação de direitos de propriedade de ativos físicos ou digitais em tokens, promovendo maior liquidez, transparência e eficiência na gestão e comercialização de ativos através de plataformas de blockchain."
          backgroundColor="white"
          colorTitle="#660EB8"
          colorContent="#706d7e"
          height="230px"
        />
        <CardServices
          title="Segurança e Conformidade"
          description="Adotando rigorosos padrões de segurança e regulamentações, a MCompany assegura a integridade e legalidade das operações de tokenização."
          backgroundColor="white"
          colorTitle="#660EB8"
          colorContent="#706d7e"
          height="230px"
        />
        <CardServices
          title="Especialização em Blockchain para Games e Corporações"
          description="Além de sua expertise em tokenização, a MCompany se destaca no desenvolvimento de blockchain para o setor de games e para soluções corporativas de multinacionais."
          backgroundColor="white"
          colorTitle="#660EB8"
          colorContent="#706d7e"
          height="230px"
        />
      </Services>

      <MarketAnalysis
        description={
          <>
            <br />
            <br />A tokenização de ativos deve atingir{' '}
            <span>US$ 16 trilhões até 2030</span>, o equivalente a cerca de{' '}
            <span>10% do PIB mundial</span>. Trata-se de um crescimento de 50
            vezes tomando como base o ano de 2022. O mercado de tokenização vive
            um momento de expansão acelerada, impulsionado pelo interesse
            crescente na tecnologia blockchain e nas possibilidades inovadoras
            que ela oferece.
            <br />
            <br />
            Com uma abordagem pioneira na tokenização de ativos, desenvolvimento
            de soluções para games e coordenação de operações de commodities, a
            MCompany se estabelece como uma marca de impacto no setor.
            <br />
            <br />
            <span>Especialização em Blockchain para Games e Corporações</span>:
            Além de sua expertise em tokenização, a MCompany se destaca no
            desenvolvimento de blockchain para o setor de games e para soluções
            corporativas de multinacionais.
          </>
        }
        backgroundColor="#660EB8"
        colorTitle="white"
        colorContent="white"
        colorSvg="white"
        news={
          <>
            O total de investimentos globais em tecnologia da informação
            (software, hardware e serviços) durante o ano de 2021 foi de{' '}
            <span>US$ 2,79 trilhões</span>, sendo que o Brasil figura na{' '}
            <span>décima posição neste ranking mundial de investimentos</span>,
            com <span>US$ 45,7 bilhões</span> aplicados, e lidera na América
            Latina.
          </>
        }
        backgroundNews="#ECF0F1"
        colorNews="rgb(112, 109, 126)"
      />

      <GeographicPresence description="Com sua base nos Emirados Árabes, a MCompany está bem posicionada para liderar no mercado global de tokenização, operando em diversos mercados internacionais. A natureza digital de seus serviços permite uma expansão fluida, respeitando as regulamentações locais e internacionais" />
    </section>
  )
}

export default MCompany
